export const nativeStyles = `
.mv-native-ad {
  text-align: left;
  position: relative;
	margin: 0 auto;
	width: fit-content;
}

.mv-native-ad + .adunit {
  height: 0px;
  width: 0px;
}

.mv-native-ad-icon {
	height: 16px;
	width: 16px;
	color: #FFF;
	background: #919191;
	font-size: 10px;
	text-align: center;
  align-items: center;
	justify-content: center;
	position: absolute;
	top: 0;
	right: 0;
}
`
